"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseCouponDialog = UseCouponDialog;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const streamline_icon_currency_euro_bill_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-currency-euro-bill.svg"));
const react_intl_1 = require("react-intl");
const styled_components_1 = require("styled-components");
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
const antd_1 = require("antd");
const Api = __importStar(require("@src/api"));
const actions_1 = __importDefault(require("@src/actions"));
const types_1 = require("@src/types");
const get_product_pricing_1 = require("@src/shared/get-product-pricing");
const useConfig_1 = require("@src/hooks/useConfig");
const queries_1 = require("@src/types/queries");
const react_query_1 = require("react-query");
const admin_context_1 = require("../admin-context");
const CreditPreselectionContent_1 = require("./applied-coupon-product-values-preselection/CreditPreselectionContent");
const PreselectionPricing_1 = require("./applied-coupon-product-values-preselection/PreselectionPricing");
const CompanyPremiumProfilePreselectionContent_1 = require("./applied-coupon-product-values-preselection/CompanyPremiumProfilePreselectionContent");
const OfferPromotionPreselectionContent_1 = require("./applied-coupon-product-values-preselection/OfferPromotionPreselectionContent");
const defaultProductAmount = {
    [types_1.ProductId.offerCredits]: 10,
    [types_1.ProductId.companyPremium]: 1,
    [types_1.ProductId.offerPromotion]: 1,
};
function UseCouponDialog({ isOpen, close }) {
    var _a;
    const config = (0, useConfig_1.useConfig)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { companyInfo, setIsCompanyPremiumActivatedDialogOpen } = (0, admin_context_1.useAdminContextValue)();
    const [appliedCoupon, setAppliedCoupon] = react_1.default.useState(null);
    const [couponInputValue, setCouponInputValue] = react_1.default.useState('');
    const [isCouponLoading, setIsCouponLoading] = react_1.default.useState(false);
    const [couponDiscount, setCouponDiscount] = react_1.default.useState(null);
    const [selectedProductAmount, setSelectedProductAmount] = react_1.default.useState(1);
    const [productId, setProductId] = react_1.default.useState(null);
    const [offerId, setOfferId] = react_1.default.useState(null);
    const [isFreeOfferPromotionCoupon, setIsFreeOfferPromotionCoupon] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const theme = (0, styled_components_1.useTheme)();
    const history = (0, react_router_1.useHistory)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const productPricing = react_1.default.useMemo(() => productId
        ? (0, get_product_pricing_1.getProductPricing)({
            productCount: selectedProductAmount,
            couponDiscount: couponDiscount || 0,
            productId,
        })
        : null, [productId, couponDiscount, selectedProductAmount]);
    const defaultCompanyBillingProfile = (_a = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyBillingProfiles) === null || _a === void 0 ? void 0 : _a.find(profile => Boolean(profile.isDefault));
    const hasAbroadBillingProfile = (defaultCompanyBillingProfile === null || defaultCompanyBillingProfile === void 0 ? void 0 : defaultCompanyBillingProfile.country) !== config.countryCode;
    const onClose = () => {
        setOfferId(null);
        setIsFreeOfferPromotionCoupon(false);
        setCouponInputValue('');
        setCouponDiscount(null);
        setSelectedProductAmount(1);
        setProductId(null);
        setAppliedCoupon(null);
        close();
    };
    const validateCoupon = async () => {
        var _a, _b;
        try {
            setIsCouponLoading(true);
            // In this case, we don't know what kind of product is user buying
            const productIds = [];
            // because the coupon is used before making order. Product ID is known only after validating coupon.
            const coupon = await Api.Admin.validateCoupon(couponInputValue, productIds);
            setSelectedProductAmount(defaultProductAmount[coupon.productId]);
            setProductId(coupon.productId);
            if (coupon.freeCreditsCount) {
                await Api.Admin.applyCoupon(couponInputValue, [coupon.productId]);
                if (coupon.productId === types_1.ProductId.offerCredits) {
                    history.pushLocalized('/admin');
                    dispatch(actions_1.default.adminToggleCreditsReplenishedDialog(true));
                }
                onClose();
                return;
            }
            if (coupon.freeMonthsPeriod) {
                await Api.Admin.applyCoupon(couponInputValue, [coupon.productId]);
                if (coupon.productId === types_1.ProductId.companyPremium) {
                    queryClient.invalidateQueries(queries_1.Queries.getCompany);
                    setIsCompanyPremiumActivatedDialogOpen(true);
                }
                onClose();
                return;
            }
            setIsFreeOfferPromotionCoupon(Boolean(coupon.freeOfferPromotion));
            setCouponDiscount(coupon.discountPercentage);
            setAppliedCoupon(couponInputValue);
            setCouponInputValue('');
            antd_1.notification.success({
                message: intl.formatMessage({ id: 'admin.order.coupon.applied' }),
            });
        }
        catch (err) {
            const errorCode = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code;
            switch (errorCode) {
                case types_1.CouponResponses.ALREADY_USED:
                    antd_1.notification.error({
                        message: intl.formatMessage({ id: 'admin.order.coupon.already_used' }),
                    });
                    break;
                case types_1.CouponResponses.EXPIRED:
                    antd_1.notification.error({
                        message: intl.formatMessage({ id: 'admin.order.coupon.expired' }),
                    });
                    break;
                case types_1.CouponResponses.NOT_APPLICABLE:
                    antd_1.notification.error({
                        message: intl.formatMessage({ id: 'admin.order.coupon.not_applicable' }),
                    });
                    break;
                default:
                    antd_1.notification.error({
                        message: intl.formatMessage({ id: 'admin.order.coupon.invalid_code' }),
                    });
            }
        }
        finally {
            setIsCouponLoading(false);
        }
    };
    const onDiscountCouponSubmit = () => {
        let redirectTarget = `/admin/objednavka?amount=${selectedProductAmount}&discountCode=${appliedCoupon}&product=${productId}`;
        if (productId === types_1.ProductId.offerPromotion && offerId) {
            redirectTarget = `${redirectTarget}&offerId=${offerId}`;
        }
        history.pushLocalized(redirectTarget);
        onClose();
    };
    const handleModalSubmit = async () => {
        try {
            if (couponDiscount) {
                onDiscountCouponSubmit();
                return;
            }
            if (isFreeOfferPromotionCoupon && productId === types_1.ProductId.offerPromotion && offerId) {
                await Api.Admin.applyCoupon(appliedCoupon, [productId], offerId);
                queryClient.invalidateQueries(queries_1.Queries.getMyOffers);
                onClose();
                history.pushLocalized('/admin');
                return;
            }
            await validateCoupon();
        }
        catch (err) {
            console.error(err);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(elements_1.Modal, { okText: couponDiscount
            ? intl.formatMessage({ id: 'admin.order.coupon.continue_to_checkout' })
            : intl.formatMessage({ id: 'admin.order.coupon.apply' }), confirmLoading: isCouponLoading, visible: isOpen, onOk: handleModalSubmit, onCancel: onClose, destroyOnClose: true, title: (0, jsx_runtime_1.jsxs)("div", { className: "font-size-l", children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.order.coupon.use_your_coupon" }), (0, jsx_runtime_1.jsx)(streamline_icon_currency_euro_bill_svg_1.default, { fill: theme.color.success, width: 40, className: "m-l-s" })] }), children: [isFreeOfferPromotionCoupon && productId === types_1.ProductId.offerPromotion && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(OfferPromotionPreselectionContent_1.OfferPromotionPreselectionContent, { offerId: offerId, setOfferId: setOfferId, setSelectedProductAmount: setSelectedProductAmount }) })), !isFreeOfferPromotionCoupon && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!couponDiscount && ((0, jsx_runtime_1.jsx)("div", { className: "flex-col", children: (0, jsx_runtime_1.jsx)(elements_1.Input, { style: { fontSize: '2rem' }, value: couponInputValue, onChange: e => { var _a; return setCouponInputValue((_a = e.target.value) === null || _a === void 0 ? void 0 : _a.toUpperCase()); }, placeholder: "JKL23ABC", maxLength: 10 }) })), couponDiscount && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "flex-col", children: (0, jsx_runtime_1.jsx)("h2", { className: "text-center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.order.coupon.coupon_with_discount", values: { discount: couponDiscount } }) }) }), productId === types_1.ProductId.offerCredits && ((0, jsx_runtime_1.jsx)(CreditPreselectionContent_1.CreditPreselectionContent, { productAmount: selectedProductAmount, setSelectedProductAmount: setSelectedProductAmount })), productId === types_1.ProductId.companyPremium && ((0, jsx_runtime_1.jsx)(CompanyPremiumProfilePreselectionContent_1.CompanyPremiumProfilePreselectionContent, { productAmount: selectedProductAmount, setSelectedProductAmount: setSelectedProductAmount })), productId === types_1.ProductId.offerPromotion && ((0, jsx_runtime_1.jsx)(OfferPromotionPreselectionContent_1.OfferPromotionPreselectionContent, { offerId: offerId, setOfferId: setOfferId, setSelectedProductAmount: setSelectedProductAmount })), productPricing && productId && ((0, jsx_runtime_1.jsx)(PreselectionPricing_1.PreselectionPricing, { productId: productId, productPricing: productPricing, hasAbroadBillingProfile: hasAbroadBillingProfile }))] }))] }))] }));
}
